import React, { ReactElement } from "react";
import Flex from "../Flex";
import { IsDefined } from "../IsDefined";

interface Props {
  leading?: React.ReactNode;
  title: React.ReactNode;
}

const AppAccordionHeader = (props: Props): ReactElement => {
  return (
    <Flex gap={8}>
      <IsDefined value={props.leading}>{(leading) => <div>{leading}</div>}</IsDefined>

      <div>{props.title}</div>
    </Flex>
  );
};

export default AppAccordionHeader;
